import { apiRequest } from "@/api/client";
import type { LoginResponse, User } from "@/types/api";

/** Autentica o usuário. Não envia token (endpoint público). */
export function login(email: string, password: string): Promise<LoginResponse> {
  return apiRequest<LoginResponse>("/auth/login", {
    method: "POST",
    body: { email, password },
    auth: false,
  });
}

/** Devolve o usuário da sessão atual (revalida o token). */
export function fetchMe(): Promise<User> {
  return apiRequest<User>("/me");
}
